// @ts-nocheck -- copied verbatim from the application being replaced.
//
// Quarantined, not exempted. This file has not been rewritten to this project's
// settings and does not pass them; checking it would report errors nobody is
// going to fix in place, and loosening the settings to accommodate it would
// apply that to code written here too. Vite still compiles it -- esbuild strips
// types without checking them.
//
// Delete this line when the file is rewritten. It is the marker for what is left
// to do, and the count of files carrying it is the size of the refactor.
import { createContext, useContext } from 'react';
import { logger } from '@/shared/observability/logger';

// User interface - Updated to match unified auth service
export interface User {
  id: string;
  username: string;
  email: string;
  name: string; // Combined firstName + lastName
  firstName: string;
  lastName: string;
  plan: string; // Derived from role
  image?: string;
  phoneNumber?: string;
  location?: string;
  role: string;
  roleDisplayName: string;
  emailVerified: boolean;
  isActive: boolean;
  isAgencyUser?: boolean;
}

// Auth context interface
export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isAgencyUser: boolean;
  isLoading: boolean; // Add loading state
  login: (user: User) => void;
  logout: () => void;
  refreshUser: () => void;
}

// Create auth context
export const AuthContext = createContext<AuthContextType | null>(null);

// Hook to use auth context
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

/**
 * @deprecated Legacy storage utilities - use UnifiedAuthStorage instead
 * Kept for backward compatibility during migration
 */
export const authStorage = {
  setAuthState: (isAuthenticated: boolean) => {
    logger.warn('⚠️ authStorage.setAuthState is deprecated. Use UnifiedAuthStorage instead.');
  },
  
  getAuthState: (): boolean => {
    return false;
  },
  
  setUser: (user: User) => {
    logger.warn('⚠️ authStorage.setUser is deprecated. Use UnifiedAuthStorage instead.');
  },
  
  getUser: (): User | null => {
    return null;
  },
  
  clearAuth: () => {
    logger.warn('⚠️ authStorage.clearAuth is deprecated. Use UnifiedAuthStorage instead.');
  }
};

/**
 * @deprecated Mock user - no longer needed with real API
 */
export const mockUser: User = {
  id: 'MOCK001',
  username: 'mockuser',
  name: 'Mock User',
  firstName: 'Mock',
  lastName: 'User',
  email: 'mock@example.com',
  plan: 'Free Plan',
  role: 'GUEST',
  roleDisplayName: 'Guest User',
  emailVerified: false,
  isActive: true,
  image: 'https://white-decaf-50172269.figma.site/_assets/v11/8df14af3464417e29cf868023d16de9421eb33dc.png'
};